<template>
	<a v-toggle-basket-preview href="#" class="toggle-basket-preview">
		<svg class="header__shopping-bag" fill="currentColor">
			<use xlink:href="#shopping-bag" />
		</svg>
		<div v-if="getItemQuantity > 0" class="header__shopping-bag-qty-badge">
			<span>{{ getItemQuantity }}</span>
		</div>

		<span>{{ $translate("HoferAntikschmuck::Template.headerBasketLabel") }}</span>
	</a>
</template>

<script>
	export default {
		computed: {
			getItemQuantity(){
				return this.$store.state.basket.data.itemQuantity
			}
		}
	}
</script>
